export const spacings = {
  space_96: '96px',
  space_88: '88px',
  space_80: '80px',
  space_72: '72px',
  space_64: '64px',
  space_56: '56px',
  space_48: '48px',
  space_40: '40px',
  space_36: '36px',
  space_32: '32px',
  space_24: '24px',
  space_20: '20px',
  space_16: '16px',
  space_12: '12px',
  space_8: '8px',
  space_6: '6px',
  space_4: '4px',
  space_2: '2px',
  space_0: '0px',
};
